export const VIRTUAL_GENOME_CREATION_FORM_NAME = "VIRTUAL_GENOME_CREATION_FORM_NAME";
export const VIRTUAL_GENOME_CREATION_FORM_KEYS = {
  COMBINANT_GENOMES: "combinant_genomes",
  GENOME_NAME: "genome_name",
  GENOME_DESCRIPTION: "genome_description",
  USER_GROUPS: "user_groups",
};
